import { SocialAuthProvider } from '../hooks/useSocialAuth';
import { getFacebookProfile, FacebookProfile } from './facebook';
import { getAmazonProfile } from './amazon';

export type SocialProfile = FacebookProfile;

const GETTERS = {
  [SocialAuthProvider.Facebook]: getFacebookProfile,
  [SocialAuthProvider.Amazon]: getAmazonProfile
};

export const getSocialProfile = (provider: SocialAuthProvider): Promise<SocialProfile> =>
  GETTERS[provider]();
